export default "__VITE_PUBLIC_ASSET__20edf319__"